export default __webpack_public_path__ + "static/media/BTC-USDC.792b889b.png";